import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {jobApplicationsList_template} from "../components/templates/jobApplicationsList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {valnetAccess_isOfRole} from "../../vendor/valnet/valnet_access/src/js/helper";
import {vnApp_emaki} from "../components/vnApp_emaki";

declare var ko: any;
declare var page: any;

export class job_applications extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: jobApplicationsList_template;
    protected pagination: pagination_template;
    protected timer;

    protected getModuleName(){

        return "job_applications";
    }

    buildContent() : Array<Element>{

        this.elementsList = new jobApplicationsList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Job Applications");


        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getfilterReference();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected listReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    public getfilterReference(): void{

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if( "getfilterReference" in this.XHRHdls ){
            this.XHRHdls["getfilterReference"].cancelAndReset();
        }

        let usrReq_url: string = '/api/job/references';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls['getfilterReference'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getfilterReference'].onReadyStateFunction = this.onFilterReferenceRequestReturn;
        this.XHRHdls['getfilterReference'].execute();
    }

    protected onFilterReferenceRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.elementsList.setBrands(responseParsed.brands)
                obj.elementsList.setStatus(responseParsed.status);
                obj.elementsList.setProfiles(responseParsed.profiles);
                obj.elementsList.setHrStatus(responseParsed.hrStatus);
                obj.setNotificationPreferences(responseParsed.notificationPreferences, responseParsed.brands);
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
            });

        }
    }

    public setNotificationPreferences(preferences, brands){

        let results = [];
        let vnApp = this.getVnAppZone().app;
        let user = vnApp.loggedUser.user;
        let roles = user.valnet_user.roles;
        let userBrands = user.brands;

        for(let brand of brands){

            let data = { brand: brand, candidateComments: false, applicationSubmissions: false, hrApprovals: false, applicationApprovals: false, applicationRejections: false }
            const index = preferences.findIndex(element => element.brand.id === brand.id);
            if (index > -1) {

                data = {
                    brand: brand,
                    candidateComments: preferences[index].candidateComments,
                    applicationSubmissions: preferences[index].applicationSubmissions,
                    hrApprovals: preferences[index].hrApprovals,
                    applicationApprovals: preferences[index].applicationApprovals,
                    applicationRejections: preferences[index].applicationRejections
                }

            } else {

                const userBrandIndex = userBrands.findIndex(item => item.id === brand.id);
                if (userBrandIndex > -1
                        && (valnetAccess_isOfRole(vnApp, vnApp_emaki.ROLE_NAME_HIRING_COORDINATOR)
                        || valnetAccess_isOfRole(vnApp, vnApp_emaki.ROLE_NAME_HIRING_MANAGER)
                        || valnetAccess_isOfRole(vnApp, vnApp_emaki.ROLE_NAME_APPLICATION_REVIEWER))) {

                    let hrApprovals = false;
                    let applicationApprovals = false;

                    for (let role of roles) {

                        if (role.id == vnApp_emaki.ROLE_NAME_HIRING_COORDINATOR || role.id == vnApp_emaki.ROLE_NAME_HIRING_MANAGER) {
                            applicationApprovals = true;
                        }
                        if (role.id == vnApp_emaki.ROLE_NAME_APPLICATION_REVIEWER) {
                            hrApprovals = true;
                        }
                    }

                    data = {
                        brand: brand,
                        candidateComments: true,
                        applicationSubmissions: true,
                        hrApprovals: hrApprovals,
                        applicationApprovals: applicationApprovals,
                        applicationRejections: true
                    }
                }
            }

            results.push(data);
        }

        this.elementsList.setPreferences(results);
    }


    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/job/applications/get/';
        this.timer = new Date().getTime();
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'articles');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });

        }
    }

    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set Jobs list
        let applications = [];
        for (let item of responseParsed.data.data) {

            applications.push({

                  id: item.id
                , idProfile: item.originalProfile.id
                , candidateName: item.fullName
                , brandName: item.originalBrand.name
                , positionName: item.originalProfile.name
                , candidateStatus: item.status.name
                , applicationStatus: item.applicationStatus.name
                , hrStatus: item.hrStatus.name
                , iconImage: item.originalBrand.iconImage
                , dateCreated: item.dateCreated
                , dateUpdated: item.dateUpdated
            })
        }

        this.elementsList.setApplications(applications);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.data.totalCount, responseParsed.data.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.data.totalCount);

        //set is Candidate
        this.elementsList.setIsCandidate(responseParsed.isCandidate);

        //set permissions
        this.elementsList.setPermissions(responseParsed.permissions);
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.elementsList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onSaveSearchPresetReturn;
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onSaveSearchPresetReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.elementsList.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onSaveFavoriteSearchPresetReturn
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onSaveFavoriteSearchPresetReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected setDefaultStatusFilters(){
        // no implementation for presist setSearchPresetsfunction
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected viewApplication(application){

        this.saveViewModule(this.getMemoryViewModel());

        let viewUrl = window.location.origin +'/job/applications/view/' + application.id;
        let editUrl = window.location.origin +'/job/applications/edit/' + application.id;
        this.savePreviousPage(viewUrl, window.location.href);
        this.savePreviousPage(editUrl, window.location.href);
        page('/job/applications/view/'+ application.id);
    }

    protected filterByPresets(filters){

        this.elementsList.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.applications;

        return templateViewModel;
    }

    public savePreferences(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("preferences-dialog"));

        let formReq_url: string = '/api/job/applications/preferences/save/';
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = this.elementsList.getTemplateViewModel().preferences();
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.elementsList.onClickTogglePreferences('close');
                    obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("preferences-dialog"));
                    page.redirect('/job/applications');
                });
            }
        });
        XHRHdl.execute();
    }

}


// WEBPACK FOOTER //
// ./js/modules/job_applications.ts